// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1UTsS","header":"PatientBlock_header__IEJKV","label":"PatientBlock_label__2grqN","option":"PatientBlock_option__3eeNm"};